import { ComponentProps, FC } from 'react'

import { clsx } from 'clsx'

import { runIfFn } from '../utils/index.js'

export type RadioProps = ComponentProps<'input'> & {
  active?: boolean
  checked?: boolean
}
export const Radio: FC<RadioProps> = props => {
  const {
    active = false,
    checked = false,
    disabled,
    children,
    className,
    ...rest
  } = props

  return (
    <div className="relative flex focus:outline-none">
      <span
        className={clsx(
          checked
            ? 'bg-action-primary border-transparent'
            : 'bg-surface border-border',
          'focus:outline-none focus-visible:ring',
          'h-4 w-4 mt-0.5 rounded-full border flex items-center justify-center',
          !disabled && 'cursor-pointer ',
          disabled && 'opacity-60 cursor-default',
          className,
        )}
        aria-hidden="true"
        {...rest}
      >
        <span className="rounded-full bg-surface w-1.5 h-1.5" />
      </span>
      <div className="ms-3 flex flex-1 flex-col">
        {runIfFn(children, {
          checked,
          active,
          disabled,
        })}
      </div>
    </div>
  )
}
